import { render, staticRenderFns } from "./SetupContact.vue?vue&type=template&id=446836b5&scoped=true"
import script from "./SetupContact.vue?vue&type=script&lang=js"
export * from "./SetupContact.vue?vue&type=script&lang=js"
import style0 from "./SetupContact.vue?vue&type=style&index=0&id=446836b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446836b5",
  null
  
)

export default component.exports